import styled from "@emotion/styled";
import { secondaryText } from "@silvertours/front-shared";
var FigureListContainer = /*#__PURE__*/ styled("div", {
    target: "e1p8nlnr0"
})("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";display:grid;grid-auto-flow:row dense;grid-template-columns:repeat(4,minmax(0,1fr));justify-items:center;gap:", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[60], " ").concat(theme.spacing[70]);
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border-width:", function(param) {
    var theme = param.theme;
    return theme.spacing[5];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";grid-template-columns:", function(param) {
    var contentLength = param.contentLength;
    return "repeat(".concat(contentLength <= 5 ? contentLength : 4, ", minmax(0, 1fr))");
}, ";}");
var Figure = /*#__PURE__*/ styled("figure", {
    target: "e1p8nlnr1"
})("grid-column:span 2 / span 2;display:flex;flex-direction:column;max-height:200px;&:nth-of-type(odd){&:last-child{grid-column-start:2;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{grid-column-start:auto;}}}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{grid-column:span 1 / span 1;}");
var FigureImage = /*#__PURE__*/ styled("img", {
    target: "e1p8nlnr2"
})("margin:", function(param) {
    var theme = param.theme;
    return "auto 0 ".concat(theme.spacing[40], " 0");
}, ";max-height:48px;max-width:120px;");
var PositionLabel = /*#__PURE__*/ styled("div", {
    target: "e1p8nlnr3"
})(secondaryText, "  margin-right:auto;margin-left:auto;margin-top:auto;");
export { Figure, FigureImage, FigureListContainer, PositionLabel };
